import { Kicker } from '@developerz/ui';
import { A } from '@solidjs/router';
import { createUniqueId, For, type JSX, Show } from 'solid-js';
import { t } from '../i18n';
import { type AdminGrant, grantState } from '../lib/adminGrants';
import { EmptyState } from './EmptyState';
import { StatusPill } from './StatusPill';
import { buttonClass } from './ui/Button';

// The grants block of one person's admin page (#5727) — presenter. A summary,
// not the history table: issue and revoke live on `/admin/grants`, which `href`
// addresses to this person, so there is one write surface for grants.

export function AdminUserGrants(props: {
  readonly grants: readonly AdminGrant[];
  readonly href: string;
}): JSX.Element {
  const headingId = createUniqueId();
  return (
    <>
      <h3 id={headingId}>
        <Kicker as="span">{t('admin.user_grants_heading')}</Kicker>
      </h3>
      <Show
        when={props.grants.length > 0}
        fallback={<EmptyState message={t('admin.user_grants_empty')} />}
      >
        <ul class="row-list" aria-labelledby={headingId}>
          <For each={props.grants}>
            {(grant) => (
              <li class="row-list__row">
                <span class="admin-row__stack">
                  <code>{grant.kind}</code>
                  <Show when={grant.amount !== null}>
                    <span class="admin-row__meta">
                      {t('admin.grants_amount_value', { amount: String(grant.amount) })}
                    </span>
                  </Show>
                </span>
                <StatusPill tone={grantState(grant).tone}>{t(grantState(grant).key)}</StatusPill>
              </li>
            )}
          </For>
        </ul>
      </Show>
      <div>
        <A class={buttonClass({ variant: 'outline', size: 'sm' })} href={props.href}>
          {t('admin.user_grants_manage')}
        </A>
      </div>
    </>
  );
}
